import { createContext, use } from 'react';

import type { UsePageType } from './use-page';

export const PageContext = createContext<UsePageType>({} as UsePageType);

export const usePageContext = () => use<UsePageType>(PageContext);
